module.exports = __webpack_public_path__ + "static/media/search-empty-state.ac6e519d.svg";